import {axios} from "@/api/config";
// 查询安全风险信息管理列表
export function listTbWorkPermitData(params) {
    return axios.get(`/tbWorkPermitData/list`, params, true);
}

// 查询安全风险信息管理详细
export function getTbWorkPermitData(id) {
    return axios.get(`/tbWorkPermitData/${id}`, id, true)
}

// 新增安全风险信息管理
export function addTbWorkPermitData(params) {
    return axios.post('/tbWorkPermitData/addTbWorkPermitData', params, false);
}

// 修改安全风险信息管理
export function updateTbWorkPermitData(params) {
    return axios.post('/tbWorkPermitData/editTbWorkPermitData', params, false);
}


// 删除安全风险信息管理
export function delTbWorkPermitData(id) {
    return axios.delete(`/tbWorkPermitData/${id}`, true)
}

